import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";

Vue.prototype.$axios = axios;

// import {
//   pageModuleseo
// } from '@/api/index'

// import 'swiper/swiper-bundle.css'; // 引入 Swiper 样式
// import VuePdfEmbed from 'vue-pdf-embed';
// Vue.use(VuePdfEmbed);

import "amfe-flexible";
// import '../flexible'; // 引入自定义的 flexible.js
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css"; // 引入Element UI样式
Vue.use(ElementUI);
import "./assets/media.css"; // 引入全局CSS文件

// import { getResourceUrl } from '@/utils/resource'
// Vue.prototype.$urlImg = getResourceUrl

Vue.config.productionTip = false;
Vue.prototype.$context_path = "/api";
new Vue({
  data() {
    return {};
  },

  methods: {},

  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
